import axios from 'src/api/axiosInstances/privateAxiosInstance';
import { ScriptConfiguration, Apps, ErrorCodes, AuditList } from '../types/scriptConfiguration';
import { ScriptConfigurationParams } from '../services/scriptConfiguration.service';

export const getScriptConfiguration = async (
  params: ScriptConfigurationParams
): Promise<ScriptConfiguration.Response> => {
  return axios.get('/qs/qatab/geterrorscriptconfig', { params });
};

export const postScriptConfiguration = async (
  scriptConfiguration: ScriptConfiguration.Request
): Promise<ScriptConfiguration.Response> => {
  return axios.post('/qs/qatab/CreateEditErrorScriptConfig', scriptConfiguration);
};

export const getApps = (params: Omit<ScriptConfigurationParams, 'appId'>): Promise<Apps.Response> => {
  return axios.get('/qs/qatab/getAppForScriptError', { params });
};

export const getErrorsCode = (params: ScriptConfigurationParams & { appId: string }): Promise<ErrorCodes.Response> => {
  // All errors statuses are returned when appId = -1
  return axios.get('/qs/qatab/getErrorsCode', { params });
};

export const getAuditList = (params: AuditList.Request): Promise<AuditList.Response> => {
  return axios.get('/qs/qatab/getAuditList', { params });
};
